import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-46a3cafe"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "image-slot"
};
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "header"
};
const _hoisted_9 = {
  class: "time"
};
const _hoisted_10 = {
  key: 0,
  class: "tag"
};
const _hoisted_11 = {
  class: "middle"
};
const _hoisted_12 = {
  class: "left"
};
const _hoisted_13 = {
  class: "image-slot"
};
const _hoisted_14 = {
  class: "cent"
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
  class: "view"
};

const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"btn-container\" data-v-46a3cafe><div class=\"more-btn\" data-v-46a3cafe><span class=\"text\" data-v-46a3cafe>查看</span><div class=\"icon-container\" data-v-46a3cafe><div class=\"icon\" data-v-46a3cafe></div></div></div></div>", 1);

import { getContentText } from '@/plugins/utils';
import { Empty } from 'zhs-components';
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    classList: {
      type: Array,
      default: () => []
    },
    menuName: {
      type: String,
      default: ''
    }
  },
  emits: ['goDetails'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const defaultImg = inject('defaultImg');
    const classData = computed(() => {
      const newList = props.classList.filter(item => item.name !== '医院简介');
      return newList;
    });
    const topNews = computed(() => {
      return props.data.find(item => item.classify_name === '医院简介') || {};
    });

    const getNewsClassList = id => {
      const newsClassList = props.data.filter(item => item.classify_id === id);
      return newsClassList;
    };

    const goDetails = item => {
      emits('goDetails', item);
    };

    return (_ctx, _cache) => {
      const _component_icon_picture = _resolveComponent("icon-picture");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_image = _resolveComponent("el-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(topNews).news_name ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "top",
        onClick: _cache[0] || (_cache[0] = $event => goDetails(_unref(topNews)))
      }, [_createVNode(_component_el_image, {
        class: "left-img",
        src: _unref(topNews).cover_url || _unref(defaultImg)
      }, {
        error: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_icon_picture)]),
          _: 1
        })])]),
        _: 1
      }, 8, ["src"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_unref(topNews).news_name), 1), _createElementVNode("span", {
        class: "desc",
        innerHTML: _unref(getContentText)(_unref(topNews).context)
      }, null, 8, _hoisted_5)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classData), (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.id
        }, [_createElementVNode("div", {
          class: "main-title",
          style: _normalizeStyle({
            marginTop: index ? '30px' : ''
          })
        }, _toDisplayString(item.name), 5), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getNewsClassList(item.id), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "item-box",
            onClick: $event => goDetails(item)
          }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(item.publish_time), 1), index === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "最新")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_image, {
            class: "img",
            src: item.cover_url || _unref(defaultImg)
          }, {
            error: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_icon_picture)]),
              _: 1
            })])]),
            _: 2
          }, 1032, ["src"]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(item.news_name), 1), _createElementVNode("div", {
            class: "desc",
            innerHTML: _unref(getContentText)(item.context)
          }, null, 8, _hoisted_16), _createElementVNode("span", _hoisted_17, "查看：" + _toDisplayString(item.view_num), 1)])]), _hoisted_18])], 8, _hoisted_7);
        }), 128))], 64);
      }), 128)), !_unref(classData).length && !_unref(topNews).news_name ? (_openBlock(), _createBlock(_unref(Empty), {
        key: 0,
        text: `暂无${__props.menuName}`
      }, null, 8, ["text"])) : _createCommentVNode("", true)])]);
    };
  }

};